import { Button } from "shared-components";

import type { JSX } from "react";

interface Props {
  onClose: () => void;
}

export const SuccessFeedback = ({ onClose }: Props): JSX.Element => {
  return (
    <div className="flex flex-col items-center text-center">
      <h2>Denúncia recebida</h2>

      <p className="mt-2 lg:mt-3">Agradecemos por nos avisar. Sua denúncia será cuidadosamente investigada.</p>

      <Button color="secondary" className="mt-5 max-w-[20.5rem] text-brand-accent" onClick={onClose}>
        Retornar à página do produto
      </Button>
    </div>
  );
};
